import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import store from "store";
import useIsDesktop from "@/hooks/useIsDesktop";
import styles from "./index.module.scss";
import AccountSet from "./AccountSet";
import WithdrawalSetting from "./WithdrawalSetting";
import PasswordSet from "./PasswordSet";
import CloseAccount from "./CloseAccount";
import LoginLog from "./LoginLog";
import SecurityCenter from "./SecurityCenter";

interface SafetyCenterProps {
  className?: string;
  attr?: unknown;
}

const SafetyCenter: React.FC<SafetyCenterProps> = ({ className }) => {
  const { userInfo, notSub } = store.user;
  const { isDesktop, isReady } = useIsDesktop();

  useEffect(() => {
    store.user.getUserInfo();
  }, []);

  if (!isReady) {
    return null;
  }

  if (isDesktop) {
    return (
      <div className={styles.desktopSpikex}>
        <SecurityCenter />
      </div>
    );
  }

  return (
    <div className={styles.mobileLegacy}>
      <div className={cx("account_safely", className)}>
        <AccountSet userInfo={userInfo} />
        {notSub && <WithdrawalSetting />}
        {notSub && <PasswordSet />}
        {notSub && <CloseAccount />}
        <LoginLog />
      </div>
    </div>
  );
};
export default observer(SafetyCenter);
